export const storage = window.localStorage;
